export { SiteKeys } from './siteKeys';
export const powerFiveConferencesIds = [2, 3, 4, 6, 9, 10];
export const groupFiveConferencesIds = [1, 5, 7, 8, 11, 91];
export const classYearClaimCutoff = new Date().getFullYear() - 6;
export const recruitsSubConfig = {
  pricing: {
    base: 149.99,
    offer: 99.99,
    period: 'yr',
    get discount() {
      return Math.round(((this.base - this.offer) / this.base) * 100) + '%';
    },
  },
};

export const womenSportKeys = [5, 6, 7, 9, 10, 11, 12, 13, 15, 17, 19, 22];
